import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>Copyright © 2023 Sungjin Park</p>
    </footer>
  );
}

export default Footer;
